import { SectionHead, TextField } from "@/components/inquiry/inquiryFields";

/**
 * StepBrand — business + social details. All fields optional; encouraged
 * because they help scoping.
 */
export const StepBrand = ({ data, onField }) => (
    <section data-testid="step-brand">
        <SectionHead
            eyebrow="Step 04 · Brand"
            title="Tell us about your brand."
            description="Optional but recommended — the more context you share, the sharper our first proposal will be."
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <TextField
                id="brand-business-name"
                label="Business Name"
                value={data.business_name}
                onChange={(e) => onField("business_name", e.target.value)}
                placeholder="Your brand or company name"
                testId="brand-business-name-input"
            />
            <TextField
                id="brand-business-type"
                label="Business Type / Industry"
                value={data.business_type}
                onChange={(e) => onField("business_type", e.target.value)}
                placeholder="e.g. Skincare, Fintech, SaaS, Coffee"
                testId="brand-business-type-input"
            />
            <TextField
                id="brand-website"
                label="Website"
                value={data.website_link}
                onChange={(e) => onField("website_link", e.target.value)}
                placeholder="https://yourbrand.com"
                testId="brand-website-input"
            />
            <TextField
                id="brand-instagram"
                label="Instagram Page"
                value={data.instagram_link}
                onChange={(e) => onField("instagram_link", e.target.value)}
                placeholder="instagram.com/yourbrand"
                testId="brand-instagram-input"
            />
            <TextField
                id="brand-facebook"
                label="Facebook Page"
                value={data.facebook_link}
                onChange={(e) => onField("facebook_link", e.target.value)}
                placeholder="facebook.com/yourbrand"
                testId="brand-facebook-input"
            />
        </div>

        <p className="mt-6 text-[11px]" style={{ color: "var(--pg-fg-muted)" }}>
            All fields are optional — skip anything that doesn't apply yet.
        </p>
    </section>
);

export default StepBrand;
